import { FormikHelpers, useFormik } from 'formik';
import { GalleryEdit, Gallery } from '../gallery';
import {
  Grid,
  TextField,
  Box,
  FormHelperText,
  Paper,
  Button,
} from '@mui/material';
import { getMediaUrl } from '../../../core/utils/image';

type GalleryProps = {
  onSubmit: (
    value: GalleryEdit,
    helpers: FormikHelpers<GalleryEdit>
  ) => Promise<void>;
  submitting: boolean;
  gallery: Gallery;
};

const EditGalleryForm = ({ onSubmit, submitting, gallery }: GalleryProps) => {
  const handleSubmit = async (
    value: GalleryEdit,
    helpers: FormikHelpers<GalleryEdit>
  ) => {
    await onSubmit(value, helpers);
  };

  const initialValues: GalleryEdit = {
    title: gallery.title,
    cover: null,
  };

  const formik = useFormik({
    initialValues,
    onSubmit: handleSubmit,
  });

  // console.log('Edit Form', initialValues);

  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={9}>
              <Paper sx={{ p: 2, pb: 3 }}>
                <Grid
                  container
                  justifyContent="space-between"
                  spacing={1}
                  sx={{ mt: 2 }}
                >
                  <Grid item alignSelf="flex-start" sx={{ flexGrow: 1 }}>
                    <TextField
                      fullWidth
                      name="title"
                      size="small"
                      type="text"
                      variant="outlined"
                      label="Title"
                      placeholder=""
                      value={formik.values.title}
                      onChange={formik.handleChange}
                      error={Boolean(formik.errors.title)}
                      helperText={formik.errors.title}
                    />
                  </Grid>

                  <Grid item sx={{ flexGrow: 1 }}></Grid>
                </Grid>
                <Grid
                  container
                  justifyContent="space-between"
                  spacing={1}
                  sx={{ mt: 2 }}
                >
                  <Grid item alignSelf="flex-start" sx={{ flexGrow: 1 }}>
                    <Grid item xs={12}>
                      Cover Image
                    </Grid>
                    <Grid item sx={{ mr: 3 }}>
                      <img
                        src={getMediaUrl(
                          gallery.media.length ? gallery.media[0] : null
                        )}
                        width="256px"
                        alt="cover"
                      />
                    </Grid>
                    <Box>
                      <input
                        type="file"
                        onChange={({ target: { files } }) => {
                          formik.setFieldValue(
                            'cover',
                            files && files.length ? files[0] : null
                          );
                        }}
                        name="cover"
                      />
                    </Box>
                    {formik.touched.cover && formik.errors.cover && (
                      <FormHelperText error>
                        {formik.errors.cover}
                      </FormHelperText>
                    )}
                  </Grid>

                  <Grid item sx={{ flexGrow: 2 }}></Grid>
                </Grid>
              </Paper>
            </Grid>

            <Grid item xs={12} sm={3}>
              <Paper sx={{ p: 2 }}>
                <Grid container>
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={submitting}
                    size="small"
                  >
                    {submitting ? 'Saving' : 'Save'}
                  </Button>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </form>
      </Box>
    </>
  );
};

export default EditGalleryForm;
